import React, { useEffect, useState } from "react";
import { Breadcrumb, Form, Select, Row, Col, Checkbox } from "antd";
import { Link, useParams,  useNavigate } from "react-router-dom";
import InputField from "../../common/htmlComponents/InputField";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { getRequest, patchRequest } from "../../axios";
import { Option } from "antd/lib/mentions";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import { useTranslation } from "react-i18next";

const options = [];
for (let i = 10; i < 36; i++) {
  options.push({
    label: i.toString(36) + i,
    value: i.toString(36) + i,
  });
}

const RFQApprovalPage = () => {
    const { t } = useTranslation();
  // const { Option } = Select;
  const { rfqId } = useParams();
  const navigate = useNavigate();
  // const rfqMaterialId = rfqId;
  const [getResponseData, setGetResponseData] = useState([]);
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [rfqNumber, setRfqNumber] = useState("");
  const [rendomId, setRendomId] = useState("");
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [showSendButton, setShowSendButton] = useState(false);
  
  const [state, setState] = useState("");


  // const res = async () => {
  //   try {

  //     let apiResponse = await getRequest(`rfq-material-details/${rfqId}`);
  //     setGetResponseData(apiResponse.data.data);
  //     setRfqNumber(apiResponse.data.data.rfq_number); 
  //     const initialState = {
  //       rfq_material_details: apiResponse.data.data.total_quantity_by_site.map(
  //         (item) => ({
  //           // id: rfqId,
  //           // rfq_master: item.rfq_master,
  //           purchase_requisition_material:
  //             item.purchase_requisition_material_id,
  //           material_total_quantity: item.material_total_quantity,
  //           amount: item.amount,
  //           rfq_site_wise_vendor: item.site_wise.map((site) => ({
  //             purchase_requisition_site_name: site.site_id,
  //             site_wise_total_quantity: site.site_wise_total_quantity,
  //             site_wise_total_amount: site.site_wise_total_amount,
  //             vendor: item?.vendors.map((item) => item.id),
  //           })),
  //         })
  //       ),
  //     };
  //     setState(initialState);
  //   } catch (err) {
  //   }
  // };

  // useEffect(() => {
  //   res();
  //   getVendor();
  // }, []);


  const res = async () => {
    try {
      let apiResponse = await getRequest(`rfq-material-details/${rfqId}`);
      setGetResponseData(apiResponse.data.data);
      setRfqNumber(apiResponse.data.data.rfq_number);
      const rendomId = apiResponse.data.data.id;
      setRendomId(rendomId)
      
      const mergedArray = apiResponse.data.data.total_quantity_by_site.map((siteItem, index) => ({
        ...siteItem,
        rfq_material_details: apiResponse.data.data.rfq_material_details,
      }));

      console.log('mergedArray ', mergedArray);
      console.log('apiResponse.data.data.total_quantity_by_site ', apiResponse.data.data.total_quantity_by_site);


      // const initialState = {
      //   rfq_material_details: mergedArray.map((item) => ({
      //     id: item.rfq_material_details.id,
      //     purchase_requisition_material: item.rfq_material_details.purchase_requisition_material,
      //     material_total_quantity: item.rfq_material_details.material_total_quantity,
      //     amount: item.rfq_material_details.amount,
      //     rfq_site_wise_vendor: item.site_wise.map((site) => ({
      //       purchase_requisition_site_name: site.site_id,
      //       site_wise_total_quantity: site.site_wise_total_quantity,
      //       site_wise_total_amount: site.site_wise_total_amount,
      //       vendor: item?.vendors ? item?.vendors?.map((vendorItem) => vendorItem?.id) : [],
      //     })),
      //   })),
      // };

      const initialState = {
        rfq_material_details: apiResponse.data.data.total_quantity_by_site.map(item => ({
        

          ...item.material_wise.map(material => ({
            id: material.purchase_requisition_material_id,
            material_total_quantity: material.material_total_quantity,
            amount: material.amount,
            rfq_site_wise_vendor:material.site_wise.map(site => ({
                purchase_requisition_site_name:  site.site_name,
               
                site_wise_total_quantity:site.site_wise_total_quantity,
                site_wise_total_amount: site.site_wise_total_amount,
                vendor: material.vendors.map(vendor => vendor.id)
              }  ))
               
             } ))
        })) };
    
    
      
      
      
      
      
      
    

      
      console.log('initialStates', initialState);

      setState(initialState);
      
    } catch (err) {
      //ErrorNotificationMsg(err);
    }
  };

  
  useEffect(() => {
    res();
    getVendor();
    getCurrency();
    console.log('state ', state);
  }, []);

  
  // useEffect(() => {
  //   res();
  
  // }, [state]);


  const getCurrency = async (data) => {
    await getRequest("business-settings/get-currency-by-business-setting/", data).then(
      (response) => {
        setCurrencySymbol(response.data.data);
      
      }
    );
  };
  const handleVendorChange = (value,ind, materialTypeIndex, siteIndex) => {
    // Create a copy of the state

    const updatedState = { ...state };
    updatedState.rfq_material_details[ind][materialTypeIndex].rfq_site_wise_vendor[
      siteIndex
    ].vendors = value;
    setState(updatedState);
    setSelectedVendors(value); // Update selectedVendors state

    // const updatedState = { ...state };
  
    // // Get the material data for the specified index
    // const materialData = updatedState.rfq_material_details[ind];
  
    // // Ensure materialData and rfq_site_wise_vendor exist
    // if (materialData && materialData.rfq_site_wise_vendor) {
    //   // Get the selected vendors from the value parameter
    //   const selectedVendors = value;
  
    //   // Update the selected vendors for the specific site
    //   materialData.rfq_site_wise_vendor[siteIndex].vendors = selectedVendors;
    };
  
    // Update the state with the modified data
    // setState(updatedState);
  

//   const handleVendorChange = (value, siteIndex, materialTypeIndex, ind) => {
//     // Create a copy of the state
//     const updatedState = { ...state };

//     // Get the material data for the specified index
//     const materialData = updatedState.rfq_material_details[ind];

//     // Ensure materialData and rfq_site_wise_vendor exist
//     if (materialData && materialData.rfq_site_wise_vendor) {
//         // Iterate over rfq_site_wise_vendor array to update vendor for each site
//         materialData.rfq_site_wise_vendor.forEach((siteData) => {
//             // Ensure siteData and material_wise exist
//             if (siteData && siteData.material_wise) {
//                 const materialWiseData = siteData.material_wise[materialTypeIndex];

//                 // Ensure materialWiseData and site_wise exist
//                 if (materialWiseData && materialWiseData.site_wise) {
//                     const siteWiseData = materialWiseData.site_wise[siteIndex];

//                     // Update the vendor value for the specific material type and site
//                     if (siteWiseData) {
//                         siteWiseData.vendor = value;
//                     }
//                 }
//             }
//         });
//     }

//     // Update the state with the modified data
//     setState(updatedState);

//     // Update selectedVendors state if needed
//     setSelectedVendors(value);
// };

  
  
  
  


  // const handleVendorChange = (value, siteIndex, materialIndex) => {
    
    // const updatedState = { ...state };

    // if (updatedState.rfq_material_details && updatedState.rfq_material_details[siteIndex] && updatedState.rfq_material_details[siteIndex].rfq_site_wise_vendor) {
    //     updatedState.rfq_material_details[siteIndex].rfq_site_wise_vendor[materialIndex].vendor = value;
    //     setState(updatedState);
    //     setSelectedVendors(value); 
    // } else {
    //     console.error("State structure doesn't match expected hierarchy");
    // }

    

// };


  const handleCheckboxChange = (ind, siteIndex, checked) => {
    if (checked) {
      const updatedState = { ...state };
      updatedState.rfq_material_details[ind].rfq_site_wise_vendor[
        siteIndex
      ].vendor =
        state?.rfq_material_details[ind]?.rfq_site_wise_vendor[
          siteIndex - 1
        ].vendor;
      setState(updatedState);
    }
  };
  console.log('state ', state);

  const handleSubmit = async () => {
    try {
    
      //setBtnLoading(true);
      const payload = {
        rfq_material_details: state.rfq_material_details,
        rfq_site_wise_vendor: state.rfq_site_wise_vendor,
      };
      let response;
      if (rfqId !== null) {
        response = await patchRequest(`rfq-material-details/${rfqId}/`, payload);
      }
      // else {
      //   response = await patchRequest(`company/${rfqId}/`, payload);
      // }

      if (response.data.success) {
        //setAddedCompanyId(response.data.data.id);

        SuccessNotificationMsg(response.data.message);
        setShowSendButton(true);
        //setFormSubmitted(true);
        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        //setBtnLoading(false);
        // navigate(`/request-for-quotation/select-vendor/${rfqId}`);
        navigate(`/request-for-quotation/email-notification/${rfqId}`);

      }
    } catch (error) {
      // setBtnLoading(false);
    }
  };
  const handleSubmitSaveDraft = async () => {
    try {
    
      //setBtnLoading(true);
      const payload = {
        rfq_material_details: state.rfq_material_details,
        rfq_site_wise_vendor: state.rfq_site_wise_vendor,
      };
      let response;
      if (rfqId !== null) {
        response = await patchRequest(`rfq-material-details/${CompanyId}/float-rfq-draft/`, payload);
      }

      // else {
      //   response = await patchRequest(`company/${rfqId}/`, payload);
      // }

      if (response.data.success) {
        //setAddedCompanyId(response.data.data.id);

        SuccessNotificationMsg(response.data.message);
        setShowSendButton(true);
        //setFormSubmitted(true);
        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        //setBtnLoading(false);
        // navigate(`/request-for-quotation/select-vendor/${rfqId}`);
      }
    } catch (error) {
      // setBtnLoading(false);
    }
  };

  const getVendor = async (data) => {
    await getRequest("rfq-material-details/get-vendor-by-company/", data).then(
      (response) => {
        setDropdownOptions(response.data.results.data);
      }
    );
  };


  // getResponseDatas.total_quantity_by_site.map((data, ind) =>{
  // })

  // function getSiteNames(siteWise) {
  //   if (!siteWise) return "";
  //   const siteNames = siteWise.map((siteData) => siteData.site_name).join(", ");
  //   return siteNames;
  // }
  console.log('state ', state)

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>RFQ - Approval </h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>RFQ - Approval</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="grid-sec FormSection Container">
        <div className="FormBody selectvendor">
          <Form>
            <Row gutter={16}>
              <Col className="TextFeild gutter-row">
                <label className="cp">RFQ Number</label>
              </Col>
              <Col className="TextFeild gutter-row">
                <InputField readOnly name="" placeholder={rfqNumber} />
              </Col>
            </Row>

            <div className="formtable">
              <Row gutter={16}>
                <Col span={2}>
                  <label className="th">Sr. No.</label>
                </Col>
                <Col span={2}>
                <label className="th">City Name</label>
              </Col>
                <Col span={3}>
                  <label className="th">Item Name</label>
                </Col>
                <Col span={3}>
                  <label className="th">Site Name</label>
                </Col>
                <Col span={2}>
                  <label className="th">Quantity</label>
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <label className="th">UOM</label>
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <label className="th">Value</label>
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <label className="th">Vendor</label>
                </Col>
                <Col span={1} className="TextFeild gutter-row">
                  <label className="th"></label>
                </Col>
              </Row>

              {/*      <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="1" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="OPC 43" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}></Col>
                  </Row>  */}


                  {
                    <React.Fragment>
                    {getResponseData.total_quantity_by_site &&
                      getResponseData.total_quantity_by_site.map((data, ind) => {
                        const siteDataMap = {};
                  
                        // Group material-wise data by site name
                        data.material_wise.forEach((materialData) => {
                          if (!siteDataMap[materialData.purchase_requisition_material_type_name]) {
                            siteDataMap[materialData.purchase_requisition_material_type_name] = [];
                          }
                  
                          siteDataMap[materialData.purchase_requisition_material_type_name].push(materialData);
                        });
                  
                        return Object.entries(siteDataMap).map(([materialTypeName, materialTypeData], materialTypeIndex, index) => (
                          
                          <React.Fragment key={`${data.purchase_requisition_material_id}-${materialTypeIndex}`}>
                         
                            {materialTypeData.map((materialData, materialDataIndex) => (
                              <React.Fragment key={`material-${materialDataIndex}`}>
                                {materialData.site_wise.map((site, siteIndex) => (
                                  <Row gutter={16} key={`site-${siteIndex}`}>
                                    <Col span={1} className="TextFeild gutter-row">
                                    {
                                      siteIndex === 0 && materialTypeIndex === 0 && ( <InputField readOnly name="" placeholder={ind + 1} /> 
                                    )}
                                    </Col>

                          
                                  <Col span={3} className="TextFeild gutter-row">
                          
                                    {
                                      siteIndex === 0 && materialTypeIndex === 0 && ( <InputField readOnly name="" placeholder={data.site_wise_city_name} /> 
                                    )}
                                  </Col>
                                  <Col span={2} className="TextFeild gutter-row">
                        
                                  {
                                    siteIndex === 0 && ( <InputField readOnly name="" placeholder={materialTypeName} /> 
                                  )}
                                </Col>
                                    <Col span={3} className="TextFeild gutter-row">
                                      <InputField
                                        readOnly
                                        name=""
                                        placeholder={site.site_name}
                                      />
                                    </Col>
                                
                                    <Col span={3} className="TextFeild gutter-row">
                                      <InputField
                                        readOnly
                                        name=""
                                        placeholder={site.site_wise_total_quantity}
                                      />
                                    </Col>
                                    <Col span={3} className="TextFeild gutter-row">
                                      <InputField
                                        readOnly
                                        name=""
                                        placeholder={materialData.unit_of_measurement}
                                      />
                                    </Col>
                                    <Col span={3} className="TextFeild gutter-row">
                                   
                                      <InputField
                                        readOnly
                                        name=""
                                        placeholder={`${currencySymbol} ${site.site_wise_total_amount}`}
                                      />
                                    </Col>
                                    {console.log(materialTypeIndex, materialDataIndex,siteIndex)}
                                    <Col span={6} className="TextFeild gutter-row">
                                      <Select
                                        mode="multiple"
                                        style={{ width: "100%" }}
                                        placeholder="Please select"
                                        disabled
                                          // value={
                                          //   state.rfq_material_details[ind]
                                          //     .rfq_site_wise_vendor[siteIndex]
                                          //     .vendor
                                          // }
                                          // value={state.rfq_material_details[materialTypeIndex]?.rfq_site_wise_vendor[siteIndex]?.vendors}
                                        
                                          value={state?.rfq_material_details[ind]?.[materialTypeIndex]?.rfq_site_wise_vendor[siteIndex]?.vendor}



                                          // onChange={(value) =>
                                          //   handleVendorChange(value, siteIndex, materialTypeIndex, ind)
                                          // }
                                          onChange={(value) =>
                                            handleVendorChange(
                                              value,
                                              ind,
                                              materialTypeIndex,
                                              siteIndex
                                            )
                                          }
                                          
                                      >
                                        {dropdownOptions.map((option) => (
                                          <Option
                                            key={option.id}
                                            value={option.id}
                                          >
                                            {option.first_name}
                                          </Option>
                                        ))}
                                      </Select>
                                    </Col>
                                    {/*siteIndex !== 0 && (
                                      <Col span={1}>
                                        <Checkbox
                                          key={ind}
                                          onChange={(e) =>
                                            handleCheckboxChange(ind, siteIndex, e.target.checked)
                                          }
                                        ></Checkbox>
                                      </Col>
                                        )*/}
                                  </Row>
                                ))}
                              </React.Fragment>
                            ))}
                          </React.Fragment>
                        ));
                      })}
                  </React.Fragment>
                  
                  }
                  
                  
                  

              {/*              <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}>
                  <Checkbox></Checkbox>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}>
                  <Checkbox></Checkbox>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}>
                  <Checkbox></Checkbox>
                </Col>
                  </Row> */}
            </div>
            <hr />

            {/*           <div className="formtable">
              <Row gutter={16}>
                <Col span={2}>
                  <label className="th">Sr. No.</label>
                </Col>
                <Col span={3}>
                  <label className="th">Item Name</label>
                </Col>
                <Col span={3}>
                  <label className="th">Site Location</label>
                </Col>
                <Col span={2}>
                  <label className="th">Quantity</label>
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <label className="th">UOM</label>
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <label className="th">Value</label>
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <label className="th">Vendor</label>
                </Col>
                <Col span={1} className="TextFeild gutter-row">
                  <label className="th"></label>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="1" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="OPC 43" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}></Col>
              </Row>
              <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}>
                  <Checkbox></Checkbox>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}>
                  <Checkbox></Checkbox>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}>
                  <Checkbox></Checkbox>
                </Col>
              </Row>
            </div>
            <hr />
            <div className="formtable">
              <Row gutter={16}>
                <Col span={2}>
                  <label className="th">Sr. No.</label>
                </Col>
                <Col span={3}>
                  <label className="th">Item Name</label>
                </Col>
                <Col span={3}>
                  <label className="th">Site Location</label>
                </Col>
                <Col span={2}>
                  <label className="th">Quantity</label>
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <label className="th">UOM</label>
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <label className="th">Value</label>
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <label className="th">Vendor</label>
                </Col>
                <Col span={1} className="TextFeild gutter-row">
                  <label className="th"></label>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="1" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="OPC 43" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}></Col>
              </Row>
              <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}>
                  <Checkbox></Checkbox>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}>
                  <Checkbox></Checkbox>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={2} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row"></Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="Ahmedabad" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="25" />
                </Col>
                <Col span={2} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="MT" />
                </Col>
                <Col span={3} className="TextFeild gutter-row">
                  <InputField readOnly name="" placeholder="₹ 2,00,000" />
                </Col>
                <Col span={8} className="TextFeild gutter-row">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                    defaultValue={["Vendor 01", "Vendor 02", "Vendor 03"]}
                    onChange={handleChange}
                    options={options}
                  />
                </Col>
                <Col span={1}>
                  <Checkbox></Checkbox>
                </Col>
              </Row>
                  </div> */}

            <div className="btnwrp2">
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Submit"
                label="Approve"
                //  onClick={() => navigate(`/request-for-quotation/rfq-material-details/${rendomId}`)}
              //loading={btnLoading}
              />
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Submit"
                label="Reject"
                // onClick={handleSubmitSaveDraft}
               
              //onClick={() => navigate("/request-for-quotation/add-rfq")}
              //loading={btnLoading}
              />
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Submit"
                label="Submit"
                //  onClick={() => navigate(`/request-for-quotation/rfq-material-details/${rendomId}`)}
              //loading={btnLoading}
              />
 
      
            </div>
            <Row gutter={[15]}>
            <Col
            xs={24}
            sm={24}
            md={12}
            lg={6}
            xl={6}
            className="TextFeild gutter-row"
            
          >
            <InputField
              name="employe_id"
              label={t("")}
              
              placeholder={t("If rejected, reason")}
              // rules={t("val_employeeId")}
              // value={state.employe_id}
              // prefix={<Name />}
              // handleInputChange={handleInputChange}
              max={50}
            />
          </Col>
            </Row>
          </Form>
        </div>
      </section>
    </>
  );
};

export default RFQApprovalPage;
